
import O1HD, { modules, services } from "../../../../../engines/gameEngine";
import utilsModel from "../../../../../engines/libs/utilsModel";
import { UI_Z_INDEX } from "../../../../../engines/modules/uiModule";
import PageBase from "../../../../../engines/modules/uiModule/PageBase";
import { KaoguArtcleSellPrams } from "../../../../../engines/modules/uiModule/UIPrams";
import { MessageEventKind } from "../../../../define/MessageEventKind";
import { BUNDLE_SMALL_NAME, getOneBundleByInstant, getOneBundleOnePrefab } from "../../../BundleResourceConfig";
import NormalGameManager from "../../../manager/NormalGameManager";
import { KaoguDataHelp } from "../kaogu/config/kaoguDataHelp";
import { getKaoguItemConfig } from "../kaogu/config/kaoguMountainConfig";
import kaoguArtcleItemBase from "./kaoguArtcleItemBase";

const { ccclass, property } = cc._decorator;

const c_price = 200000;
@ccclass
export default class kaoguArtclePage extends cc.Component {
    @property({ type: cc.Node, displayName: "物品显示节点" })
    itemGroup: cc.Node = null;
    @property({ type: cc.Label, displayName: "泥土物件数量" })
    lab_insideNum: cc.Label = null;
    @property({ type: cc.Label, displayName: "锤子次数" })
    lab_chuiziTimes: cc.Label = null;
    @property({ type: cc.Node, displayName: "无锤子次数" })
    unchuiziTimes: cc.Node = null;
    @property({ type: cc.Node, displayName: "有锤子次数" })
    hasChuiziTimes: cc.Node = null;

    // @property({ type: cc.Label, displayName: '扫描费用' })
    // lab_XUse: cc.Label = null;

    @property({ type: cc.Node, displayName: "横幅---" })
    hengFU: cc.Node = null;

    // @property({ type: cc.Node, displayName: 'x光特效' })
    // Xlight: cc.Node = null;

    private readonly MaxUse: number = 1000;
    protected onLoad(): void {

    }
    protected update(dt: number): void {
        this.lab_insideNum.string = `x${KaoguDataHelp.getEarthIDList().length}`
        this.lab_chuiziTimes.string = `${KaoguDataHelp.getChuiziTimes()}`
        this.unchuiziTimes.active = KaoguDataHelp.getChuiziTimes() <= 0;
        this.hasChuiziTimes.active = !this.unchuiziTimes.active
        // this.lab_XUse.string = this.MaxUse + "万"
    }
    protected start(): void {
        this.newItem();
    }
    artcleItem: kaoguArtcleItemBase = null;
    async newItem() {

        let id = KaoguDataHelp.getEarthIDList()[0];
        if (id == null) {
            // 没有东西怎么还让进呢
            this.onClickBack();
            return
        }

        let info = getKaoguItemConfig[id];
        this.itemGroup.x = 750
        let node: cc.Node;
        let filePath = '';
        let pName = KaoguDataHelp.getEarthPrefabName();
        if (pName == null) {
            let name = info.itemPerfab ? info.itemPerfab[Math.floor(Math.random() * info.itemPerfab.length)] : "kaoguArticleItemBase";
            KaoguDataHelp.setEarthPrefabName(name)

            filePath = `kaoguArticle/articleItem/${name}`;
        } else {
            filePath = `kaoguArticle/articleItem/${pName}`;
        }

        let prefab = await getOneBundleOnePrefab(BUNDLE_SMALL_NAME.kaogu, filePath);
        node = cc.instantiate(prefab);

        node.setParent(this.itemGroup)
        node.y = -100
        // if (info.randomAngle) {
        //     let index = Math.floor(Math.random() * 4);
        //     node.angle = [90, -90, 0, 180][index]
        //     // node.getChildByName("imgItem").angle=Math.random()*360
        // }

        cc.tween(this.itemGroup)
            .to(0.5, { x: 0 })
            .start()
        this.artcleItem = node.getComponent(kaoguArtcleItemBase)
        this.artcleItem.init(info, async () => {
            console.error("揭开了回调")
            // 直接删除物件
            KaoguDataHelp.delEarthItem();

            KaoguDataHelp.setEarthPrefabName(null)
            O1HD.getManagers().soundMgr.playSound("kaogu/openbao");;

            // node.destroy();
            // node.active=true;
            this.hengFU.active = false;

            let page: PageBase;
            let prams: KaoguArtcleSellPrams = {
                id: info.id,
                SellBack: async (sPrice: number = 1) => {
                    // 开采了
                    this.itemGroup.x = 750
                    node.destroy();
                    this.hengFU.active = true;
                    this.showPageInfo();
                    O1HD.getServices().userSrv.setCoins(info.sellPrice * sPrice, true, this.node);
                    this.newItem();
                },
                PackageBack: () => {
                    // 放入背包
                    if (info.itemID == null) {
                        console.error("没有对应物品ID怎么放背包")
                        return
                    }
                    this.itemGroup.x = 750
                    node.destroy();
                    this.showPageInfo();
                    this.hengFU.active = true;

                    NormalGameManager._instance.onPushGoods(info.itemID, 1);
                    this.newItem();
                    O1HD.emit(MessageEventKind.EventName.REFRESH_KAOKU_COLLECT_STATE);
                }
            }

            
            page = await modules().uiControlModule.OpenPage("kaoguArticle/kaoguArtcleSellPage", UI_Z_INDEX.DIALOG, prams, getOneBundleByInstant(BUNDLE_SMALL_NAME.kaogu), true);

        }, () => {
            // this.artcleItem.node.destroy()
            this.hengFU.active = true;
            this.showPageInfo();
            KaoguDataHelp.delEarthItem();
            // this.newItem();
            node.destroy();
            this.newItem();
        })
    }

    async onClickBack() {
        O1HD.getManagers().soundMgr.playSound('anNiu');
        this.node && this.node.isValid && this.node.destroy();
    }

    showPageInfo() {
        this.hengFU.active = true;
        this.node.getChildByName("mask").children[0].active = true;
        this.node.getChildByName("nodeBottom").active = true;
    }

    private canX: boolean = true;
    onClickXguang() {

        // if (O1HD.getServices().userSrv.getCoins() > this.MaxUse * 10000) {
        //     // GameDataHelp.addownerCapital(-info.buyPrice);//-info.buyPrice);
        //     // GameDataHelp.pushExpensesDateInfo("购买考古地", 0, info.buyPrice)
        //     if (this.artcleItem && !this.artcleItem.wasSaoMiao) {
        //         if (!this.canX) {
        //             return
        //         }
        //         O1HD.getServices().userSrv.setCoins(-this.MaxUse * 10000, true);
        //         this.Xlight.y = 283.774;
        //         this.Xlight.active = true;
        //         this.canX = false;
        //         cc.tween(this.Xlight).to(3, { y: -400 }).call(() => {
        //             this.Xlight.active = false;
        //             this.artcleItem.showSaoMiao(() => {
        //                 this.canX = true;
        //             });
        //         }).start()
        //     }
        // } else {
        //     O1HD.getModules().uiControlModule.showMessageBox("资金不够")
        // }
    }

    onClickSell(event: cc.Event.EventTouch) {
        let node = event.getCurrentTarget();
        O1HD.getManagers().soundMgr.playSound("anNiu");
        cc.game.pause()
        utilsModel.loadAndShowVideoAdTrans(async () => {
            cc.game.resume()
            O1HD.getServices().userSrv.setCoins(c_price, true, node);
            this.nextGoods();
        }, () => {
            cc.game.resume()

        }, null, '矿区提前卖出')

    }


    clickTime:number = null;
    async onClickGua() {
        O1HD.getManagers().soundMgr.playSound('anNiu');
        if (!this.artcleItem || !this.artcleItem.isValid || this.artcleItem.cantouch) return;
        if (KaoguDataHelp.getChuiziTimes() > 0) {
            KaoguDataHelp.addChuiziTimes(-1)
            this.artcleItem.cantouch = true;
            // this.hengFU.active=false;
            // this.node.getChildByName("mask").children[0].active=false;
            this.node.getChildByName("nodeBottom").active = false;
        } else {

            if (this.clickTime != null && new Date().getTime() - this.clickTime < 3000) return;
            this.clickTime = new Date().getTime()
            cc.game.pause()
            utilsModel.loadAndShowVideoAdTrans(async () => {
                cc.game.resume()
                KaoguDataHelp.addChuiziTimes(5);
            }, () => {
                cc.game.resume()

            }, null, '增加锤子次数')
        }
    }
    onClickGiveUp() {
        O1HD.getManagers().soundMgr.playSound('anNiu');
        this.nextGoods();
    }

    nextGoods() {
        if (!this.artcleItem || !this.artcleItem.isValid) return;
        cc.tween(this.itemGroup)
            .to(0.5, { x: -750 })
            .call(() => {
                this.artcleItem.node.destroy()
                KaoguDataHelp.delEarthItem();

                KaoguDataHelp.setEarthPrefabName(null)
                this.newItem();
            })
            .start()
    }
}